<template>
    <el-card class="page_card" ref="card" v-loading="!is_ok">
        <div slot="header" class="clearfix">
            <span>汇总数据</span>
        </div>
        <el-form inline :model="selectForm" ref="selectForm">
            <el-form-item label="企业名称/简称">
                <el-select
                    v-model="selectForm.comId"
                    :multiple="false"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入企业名称/简称"
                    @change="changeCom">
                    <el-option
                        v-for="item in componys"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="一次过磅时间">
                <el-date-picker
                    v-model="selectForm.timeRange"
                    type="datetimerange"
                    align="right"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['08:00:00', '07:59:59']">
                </el-date-picker>
            </el-form-item>
             <el-form-item label="">
                <el-button plain type="primary" @click="selectSubmit()">查 询</el-button>
                <el-button plain @click="resetSelect()">重 置</el-button>
                <el-button plain type="success" @click="exportExcel"> <svg-icon icon-class="xls" /> 导出到excel</el-button>
            </el-form-item>
        </el-form>
        <el-table show-summary :summary-method="getSummaries" ref="table" :data="list" :max-height="tableMaxHeight">
            <el-table-column label="企业名称" width="" align="center">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.comName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="车数(计划数)" width="" align="center">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.totalCars}}</span>
                </template>
            </el-table-column>
            <el-table-column label="总提货量(吨)" width="" align="center">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.totalLoad==null?'0.00':scope.row.totalLoad}}</span>
                </template>
            </el-table-column>
            <el-table-column label="总销售金额(元)" width="" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.totalAmount==null?'0.00':parseNums(scope.row.totalAmount)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="优惠金额(元)" width="" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{parseNums(scope.row.discountTotal)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="结算金额(元)" width="" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{parseNums(scope.row.settlementAmount)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="结算均价(元)" width="" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{parseNums(scope.row.averageSettlementPrice)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="总收货款(元)" width="" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.totalCollection==null?'0.00':parseNums(scope.row.totalCollection)}}</span>
                </template>
            </el-table-column>
        </el-table>
        <!-- <footer style="height: 50px;position: absolute;bottom: 10px;width: calc(100% - 40px);">
            <el-pagination
                style="float: left;position: relative;top: 10px;"
                @current-change="pageChange"
                :current-page.sync="selectForm.pageNum"
                :page-size="selectForm.pageSize"
                :hide-on-single-page="false"
                layout="total, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </footer> -->
    </el-card>
</template>
<script>
import request from '@/utils/request'
import defaultSetting from '@/settings'
import {getToken} from '@/utils/auth'
export default {
    name:'summary_table',
    data(){
        return{
            is_ok:false,
            componys:[],
            selectForm:{
                comId:"",
                timeRange:[],
                pageNum:1,
                pageSize:9999999
            },
            tableMaxHeight:0,
            total:0,
            list:[],
            baseUrl:'',
            listData:{},
            totalData:{}
        }
    },
    methods:{
        getSummaries(param) {
            const { columns, data } = param;
            console.log(JSON.stringify(columns))
            const sums = [];
            columns.forEach((column, index) => {
                switch (column.label) {
                    case '企业名称':sums[index] = this.totalData.sumRow;
                        break;
                    case '车数(计划数)':sums[index] = this.totalData.totalCar;
                        break;
                    case '总提货量(吨)':sums[index] = this.totalData.totalLoad;
                        break;
                    case '总销售金额(元)':sums[index] = this.totalData.totalAmount;
                        break;
                    case '优惠金额(元)':sums[index] = this.totalData.totalDiscount;
                        break;
                    case '结算金额(元)':sums[index] = this.totalData.totalSettlementAmount;
                        break;
                    case '结算均价(元)':sums[index] = this.totalData.totalAverageSettlementPrice;
                        break;
                    case '总收货款(元)':sums[index] = this.totalData.totalCollection;
                        break;
                    default:
                        break;
                }
            });
            return sums;
        },
        resetSelect(){
            this.selectForm = {
                comId:"",
                timeRange:[],
                pageNum:1,
                pageSize:9999999
            };
            this.$refs["selectForm"].resetFields();
            this.getData();
        },
        selectSubmit(){
            this.getData();
        },
        changeCom(e){
            this.selectForm.comId=e;
            this.getData();
        },
        getCompany(){
            request.get("company/option").then(res=>{
                this.componys = res.data;
                this.componys.push( {id:"",name:"全部"})
            }).catch(err=>{
            });
        },
        getData(){
            if (this.selectForm.timeRange == null || this.selectForm.timeRange == "") {
                this.selectForm.timeRange = [];
            }
            request.post("report/summary",this.selectForm).then(res=>{
                this.listData=res.data;
                this.totalData = {
                    sumRow: this.stateFormat(res.data.sumRow), 
                    totalCar: this.stateFormat(res.data.totalCar), 
                    totalLoad: this.stateFormat(res.data.totalLoad.toFixed(2)), 
                    totalAmount: this.stateFormat(res.data.totalAmount.toFixed(2)), 
                    totalCollection: this.stateFormat(res.data.totalCollection.toFixed(2)), 
                    totalDiscount: this.stateFormat(res.data.totalDiscount.toFixed(2)), 
                    totalSettlementAmount: this.stateFormat(res.data.totalSettlementAmount.toFixed(2)), 
                    totalAverageSettlementPrice: this.stateFormat(res.data.totalAverageSettlementPrice.toFixed(2)), 
                }
                this.list = res.data.pageInfo.list;
                this.total = res.data.pageInfo.total;
                this.is_ok = true;
                this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-105;
            }).catch(err=>{
                this.is_ok = true;
                this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-105;
            });
        },
        stateFormat(cellValue) {
			cellValue += '';
			if (!cellValue.includes('.')) cellValue += '.';
			return cellValue.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
				return $1 + ',';
			}).replace(/\.$/, '');
		},
        parseNums(n,is_int=false) {
            //转化成字符串
            let str = n.toString();
            //若是整数自动补全小数位
            if (-1 == str.indexOf(".")) {
                str = str + ".00"
            }
            if(str.indexOf(".")!=-1){
                let x = str.indexOf('.') + 1;   //小数点的位置
                let y = str.length - x;  //小数的位数
                if(y > 0 && y == 1){
                    str = str + "0"
                }
            }
            //全部替换
            if (-1 != str.indexOf(",")) {
                str = str.replace(new RegExp(',', "g"), "")
            }
            let intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ',');//取到整数部分
            if(is_int){
                return intSum;
            }
            let dot = str.substring(str.length, str.indexOf("."))//取到小数部分搜索
            let ret = intSum + dot;
            return ret;
        },
        //分页改变
        pageChange(page){
            this.selectForm.pageNum = page;
            this.getData();
        },
        //保存到excel文件中
        async exportExcel(){
            try{
                let res = await fetch(this.baseUrl+"/report/summary/excel",{
                    method:"POST",
                    headers:{
                        "Authorization":getToken(),
                        "Content-Type":"application/json;charset=utf-8"
                    },
                    body:JSON.stringify(this.selectForm)
                });
                let blob = await res.blob();
                const a= document.createElement("a")
                a.href = URL.createObjectURL(blob)
                a.download = "汇总表.xls"
                a.click()
                URL.revokeObjectURL(a.href)
                this.$message.success("导出成功!");
            }catch(err){
            }finally {
            }
        },
    //     getSummaries(param) {
    //         const { columns, data } = param;
    //         const sums = [];
    //         columns.forEach((column, index) => {
    //             if (index === 0) {
    //                 sums[index] = '合计';
    //                 return;
    //             }else if(index === 1){
    //                 sums[index] = this.listData.totalCar;
    //                 return;
    //             }else if(index === 2){
    //                 sums[index] = this.parseNums(this.listData.totalLoad);
    //                 return;
    //             }else if(index === 3){
    //                 sums[index] = this.parseNums(this.listData.totalAmount);
    //                 return;
    //             }else if(index === 4){
    //                 sums[index] = this.parseNums(this.listData.totalCollection);
    //                 return;
    //             }
    //         });
    //         return sums;
    //   },
      getNextDate(date,day){
        let dd=new Date(date);
        dd.setDate(dd.getDate()+day);
        let y=dd.getFullYear();
        let m=dd.getMonth()+1 < 10 ? '0'+(dd.getMonth()+1) : dd.getMonth()+1;
        let d=dd.getDate() < 10 ? '0'+ dd.getDate() : dd.getDate()
        return y+'-'+m+'-'+d;
      }
    },
    created(){
        this.baseUrl = process.env.VUE_APP_BASE_API+"/"+defaultSetting.api_version;
    },
    mounted(){
        let dd=new Date();
        let y=dd.getFullYear();
        let m=dd.getMonth()+1 < 10 ? '0'+(dd.getMonth()+1) : dd.getMonth()+1;
        let d=dd.getDate() < 10 ? '0'+ dd.getDate() : dd.getDate()
        let startTime=`${this.getNextDate(y+'-'+m+'-'+d,-1)} 08:00:00`
        let endTime=`${this.getNextDate(y+'-'+m+'-'+d,-0)} 7:59:59`
        this.selectForm.timeRange.push(startTime,endTime)
        this.getData();
        this.getCompany();                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
    }
}
</script>
<style scoped lang="scss">

</style>
